// apps/web/src/components/shared/material-nc-badge.tsx — Fase 02, Plano 09 (D-13).
//
// Badge transversal de material não conforme: permanece disponível no estoque/movimentação,
// porém com alerta visual persistente em todas as telas onde o lote aparece (D-13).

import { type ReactElement } from 'react';

interface MaterialNcBadgeProps {
  readonly temNc?: boolean;
  readonly className?: string;
}

export function MaterialNcBadge({ temNc = true, className = '' }: MaterialNcBadgeProps): ReactElement | null {
  if (!temNc) return null;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-bold bg-red-100 text-red-800 border border-red-200 shadow-sm animate-pulse ${className}`}
      title="Material não conforme — saldo disponível no estoque com alerta de qualidade (D-13)"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-red-600" />
      não conforme — disponível com alerta
    </span>
  );
}
